import { render, staticRenderFns } from "./editArticle.vue?vue&type=template&id=02f2b629&scoped=true&"
import script from "./editArticle.vue?vue&type=script&lang=ts&"
export * from "./editArticle.vue?vue&type=script&lang=ts&"
import style0 from "./editArticle.vue?vue&type=style&index=0&id=02f2b629&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f2b629",
  null
  
)

export default component.exports